const Footer = () => {
    return (
        <footer>
            <p>Made with &#x2665; by Mohammed Shaikh </p>
            <p>2023&copy; <a href="http://JunoCollege.com" target="_blank" rel="noopener noreferrer">
            JunoCollege</a></p>
        </footer>
    )
}
export default Footer;